const e = () => (/* @__PURE__ */ new Date()).getFullYear();
export {
  e as default
};
